import { render } from "./contract-details-modal.vue?vue&type=template&id=246252ae&ts=true"
import script from "./contract-details-modal.ts?vue&type=script&lang=ts&external"
export * from "./contract-details-modal.ts?vue&type=script&lang=ts&external"

import "./contract-details-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__